import React, { useEffect, useState } from 'react';
import {
  formatUrgentCountdown,
  getUrgentRemainingMs,
  parseUrgentDeadline,
  shouldBlinkUrgent,
} from '../../utils/urgentDeadlineUtils';

const UrgentCountdownBadge = ({
  deadlineAt,
  estimateMinutes,
  compact = false,
  className = '',
  blink = false,
}) => {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (!parseUrgentDeadline(deadlineAt)) return undefined;
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, [deadlineAt]);

  const label = formatUrgentCountdown(deadlineAt, now);
  if (!label) return null;

  const remaining = getUrgentRemainingMs(deadlineAt, now);
  const near = shouldBlinkUrgent(deadlineAt, estimateMinutes, now);
  const overdue = remaining != null && remaining <= 0;

  return (
    <span
      className={`inline-flex items-center gap-1 min-h-6 px-2 py-0.5 rounded-full text-[10px] font-bold border flex-shrink-0 tabular-nums ${
        overdue
          ? 'bg-red-600 text-white border-red-700'
          : near
            ? 'bg-red-100 text-red-800 border-red-300 dark:bg-red-950/50 dark:text-red-200 dark:border-red-700'
            : 'bg-red-50 text-red-700 border-red-200 dark:bg-red-950/35 dark:text-red-200 dark:border-red-800/60'
      } ${blink && near ? 'wl-urgent-blink' : ''} ${className}`}
      title={`Urgent deadline: ${parseUrgentDeadline(deadlineAt)?.toLocaleString?.() || deadlineAt}`}
    >
      <span aria-hidden="true">⏱</span>
      <span className={compact ? '' : 'leading-tight'}>{label}</span>
    </span>
  );
};

export default UrgentCountdownBadge;
